export const STORAGE_KEYS = {
  PAGE_QUERY_FILTERS: 'query-filters',
  GRID_STATE: 'grid-state',
};
